import React from "react";
import "./App.css";
import SocoDemo from "./components/soco/soco-demo";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AprilDemo from "./components/april/april-demo";
import MadpDemo from "./components/madp/madp-demo";
import Home from "./components/home";
import MngBikeDemo from "./components/mng-bike/mng-bike-demo";
import CustomDemo from "./components/custom/custom-demo";
import AxaBuildingDemo from "./components/axa/building/container";
import StellantisDemo from "./components/stellantis/stellantis-demo";
function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/building" element={<AxaBuildingDemo />} />
          <Route path="/mng-bike" element={<MngBikeDemo />} />
          <Route path="/april" element={<AprilDemo />} />
          <Route path="/madp" element={<MadpDemo />} />
          <Route path="/soco" element={<SocoDemo />} />
          <Route path="/stellantis" element={<StellantisDemo />} />
          <Route path="/custom" element={<CustomDemo />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
